<p-dialog
    appDialogoPadrao="pi pi-send"
    descricao="Convocação dos participantes da reunião."
    closeAriaLabel="Fechar"
    [header]="titulo"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: 'min(86rem, calc(100vw - 2rem))' }"
    appendTo="body"
    styleClass="dialogo-convocacoes"
    (onHide)="fechar()"
>
    <section class="convocacoes">
        @if (erro) {
            <div class="alerta erro">
                <i class="pi pi-times-circle alerta-icone"></i>
                <span>{{ erro }}</span>
            </div>
        }
        @if (mensagem) {
            <div class="alerta sucesso">
                <i class="pi pi-check-circle alerta-icone"></i>
                <span>{{ mensagem }}</span>
            </div>
        }

        <div class="convocacoes-resumo">
            <div class="resumo-identidade">
                <div class="resumo-icone">
                    <i class="pi pi-send"></i>
                </div>
                <div class="min-w-0">
                    <h2>{{ reuniao()?.codigo ? 'Reunião ' + reuniao()?.codigo : 'Convocações' }}</h2>
                    <p>{{ reuniao()?.nomeComissao || 'Participantes e convidados da reunião' }}</p>
                </div>
            </div>

            <div class="resumo-indicadores">
                <div class="resumo-indicador">
                    <span>{{ totalParticipantes }}</span>
                    <small>Participantes</small>
                </div>
                <div class="resumo-indicador">
                    <span>{{ totalDestinatariosEmailSelecionados }}</span>
                    <small>Selecionados</small>
                </div>
                <div class="resumo-indicador sucesso">
                    <span>{{ totalEmailsEnviados }}</span>
                    <small>E-mails enviados</small>
                </div>
                <div class="resumo-indicador aviso">
                    <span>{{ totalEmailsPendentes }}</span>
                    <small>Pendentes</small>
                </div>
                <div class="resumo-indicador">
                    <span>{{ totalPresencasConfirmadas }}</span>
                    <small>Presenças</small>
                </div>
            </div>
        </div>

        <div class="convocacoes-topo-grid">
            <app-card-content [icon]="'pi pi-calendar'" [title]="'Dados da Convocação'">
                <div class="dados-campos">
                    <label>
                        <span>Data da convocação</span>
                        <input pInputText type="date" [(ngModel)]="dtConvocacao" [disabled]="!permiteAlteracao || carregando || salvando" />
                    </label>
                    <label>
                        <span>Data do ato de concessão</span>
                        <input pInputText type="date" [(ngModel)]="dtAtoConcessao" [disabled]="!permiteAlteracao || carregando || salvando" />
                    </label>
                    <label class="observacao">
                        <span>Observações</span>
                        <textarea pInputText rows="2" [(ngModel)]="dsObservacao" [disabled]="!permiteAlteracao || carregando || salvando"></textarea>
                    </label>
                    <button type="button" pButton label="Salvar dados" icon="pi pi-save" [appCan]="roleEditar" [disabled]="!permiteAlteracao || carregando || salvando" (click)="salvarContexto()"></button>
                </div>
            </app-card-content>

            <app-card-content [icon]="'pi pi-user-plus'" [title]="'Incluir Convidado'">
                <button card-header type="button" pButton label="Buscar solicitante" icon="pi pi-search" [appCan]="roleEditar" [disabled]="!permiteAlteracao || salvando" (click)="abrirPesquisaConvidado()"></button>
                <div class="convidado-card">
                    <i class="pi pi-user-plus"></i>
                    <span>Inclua convidados extras pesquisando o solicitante no cadastro de pessoas.</span>
                </div>
            </app-card-content>
        </div>

        <div class="barra-acoes">
            <div class="barra-acoes-cabecalho">
                <div>
                    <strong>Ações da convocação</strong>
                    <span>{{ totalParticipantes }} participante(s) na lista</span>
                </div>
                <button type="button" pButton label="Recarregar" icon="pi pi-refresh" severity="secondary" [outlined]="true" [disabled]="carregando" (click)="carregar()"></button>
            </div>

            @if (!permiteAlteracao && !carregando) {
                <div class="aviso-bloqueio">
                    <i class="pi pi-lock"></i>
                    <span>Convocações editáveis apenas para reuniões agendadas ou remarcadas.</span>
                </div>
            }

            <div class="acoes-grupo">
                <button
                    type="button"
                    pButton
                    [label]="rotuloMarcarTodos"
                    [icon]="iconeMarcarTodos"
                    severity="secondary"
                    [outlined]="true"
                    [appCan]="roleEditar"
                    [disabled]="!permiteAlteracao || carregando || salvando || !participantes.length"
                    (click)="marcarTodos()"
                ></button>
                <button
                    type="button"
                    pButton
                    [label]="rotuloSelecionarEmails"
                    icon="pi pi-list-check"
                    severity="secondary"
                    [outlined]="true"
                    [disabled]="carregando || salvando || !participantes.length"
                    (click)="alternarTodosDestinatariosEmail()"
                ></button>
                <button
                    type="button"
                    pButton
                    [label]="totalDestinatariosEmailSelecionados ? 'Enviar selecionados (' + totalDestinatariosEmailSelecionados + ')' : 'Enviar selecionados'"
                    icon="pi pi-send"
                    [appCan]="roleEnviarEmail"
                    [disabled]="!permiteAlteracao || carregando || salvando || !totalDestinatariosEmailSelecionados"
                    (click)="enviarEmails()"
                ></button>
                <button
                    type="button"
                    pButton
                    [label]="historicoEmailsVisivel ? 'Ocultar histórico' : 'Histórico de e-mails'"
                    icon="pi pi-history"
                    severity="secondary"
                    [outlined]="true"
                    [disabled]="carregando"
                    (click)="alternarHistoricoEmails()"
                ></button>
            </div>
        </div>

        <app-card-content [icon]="'pi pi-users'" [title]="'Participantes'">
            @if (!carregando && participantes.length) {
                <span card-header class="badge-contador">{{ participantes.length }}</span>
            }
            <div class="tabela-wrapper">
                <table class="tabela-convocacoes">
                    <thead>
                        <tr>
                            <th class="coluna-selecao">Enviar</th>
                            <th>Nome</th>
                            <th>Tipo</th>
                            <th>E-mail</th>
                            <th>Presença</th>
                            <th>Ato</th>
                            <th>Passagem</th>
                            <th>Confirmação</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @if (carregando) {
                            <tr>
                                <td colspan="9" class="vazio">
                                    <div class="estado-carregando">
                                        <i class="pi pi-spin pi-spinner"></i>
                                        <span>Carregando convocações...</span>
                                    </div>
                                </td>
                            </tr>
                        } @else if (!participantes.length) {
                            <tr>
                                <td colspan="9" class="vazio">
                                    <div class="estado-vazio">
                                        <i class="pi pi-users"></i>
                                        <span>Nenhum membro/convidado encontrado.</span>
                                    </div>
                                </td>
                            </tr>
                        } @else {
                            @for (participante of participantes; track (participante.idMembroComissao ?? participante.idSolicitante) + '-' + (participante.ufMembroComissao ?? participante.ufSgUf)) {
                                <tr [class.convidado]="participante.idParticipacao === 3 || participante.idParticipacao === 4">
                                    <td class="coluna-selecao">
                                        <input
                                            type="checkbox"
                                            class="checkbox-email"
                                            [checked]="destinatarioEmailSelecionado(participante)"
                                            [disabled]="carregando || salvando || !destinatarioEmailSelecionavel(participante)"
                                            (change)="alternarDestinatarioEmail(participante, $any($event.target).checked)"
                                            title="Selecionar para envio de e-mail"
                                        />
                                    </td>
                                    <td>
                                        <div class="participante-info">
                                            <strong>{{ participante.nmSolicitante || '-' }}</strong>
                                            <small>{{ participante.idMembroComissao || participante.idSolicitante }}/{{ participante.ufMembroComissao || participante.ufSgUf }}</small>
                                        </div>
                                    </td>
                                    <td>
                                        <span class="tag-tipo" [class.tag-convidado]="participante.idParticipacao === 3 || participante.idParticipacao === 4">{{ rotuloTipo(participante) }}</span>
                                    </td>
                                    <td>
                                        <div class="email-status">
                                            @if (participante.inStatusEnvioEmailOk === 'S') {
                                                <span class="pill sucesso" [title]="statusEmail(participante)"><i class="pi pi-check"></i> Enviado</span>
                                            } @else if (participante.inStatusEnvioEmailErro === 'N') {
                                                <span class="pill erro" [title]="statusEmail(participante)"><i class="pi pi-times"></i> Erro</span>
                                            } @else {
                                                <span class="pill neutro"><i class="pi pi-clock"></i> Pendente</span>
                                            }
                                            @if (participante.nmEmail) {
                                                <small>{{ participante.nmEmail }}</small>
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <select [ngModel]="participante.inPresenca || ''" [appCan]="roleEditar" [disabled]="!permiteAlteracao || salvando" (ngModelChange)="alterarPresenca(participante, $event)">
                                            <option value="">Pendente</option>
                                            <option value="P">Presente</option>
                                            <option value="V">Pres. virtual</option>
                                            <option value="A">Ausente</option>
                                            <option value="J">Aus. justificada</option>
                                        </select>
                                    </td>
                                    <td>
                                        <button type="button" class="botao-toggle" [class.ativo]="participante.inAtoConcessao === 'S'" [appCan]="roleEditar" [disabled]="!permiteAlteracao || salvando" (click)="alternarAto(participante)">
                                            <i class="pi" [class.pi-check]="participante.inAtoConcessao === 'S'" [class.pi-minus]="participante.inAtoConcessao !== 'S'"></i>
                                            {{ participante.inAtoConcessao === 'S' ? 'Sim' : 'Não' }}
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            class="botao-toggle"
                                            [class.ativo]="participante.inEmissaoPassagem === 'S'"
                                            [appCan]="roleEditar"
                                            [disabled]="!permiteAlteracao || salvando || participante.inAtoConcessao !== 'S'"
                                            (click)="alternarPassagem(participante)"
                                        >
                                            <i class="pi" [class.pi-check]="participante.inEmissaoPassagem === 'S'" [class.pi-minus]="participante.inEmissaoPassagem !== 'S'"></i>
                                            {{ participante.inEmissaoPassagem === 'S' ? 'Sim' : 'Não' }}
                                        </button>
                                    </td>
                                    <td>
                                        <span
                                            class="pill"
                                            [ngClass]="{
                                                sucesso: participante.inPresenca === 'P' || participante.inPresenca === 'V',
                                                erro: participante.inPresenca === 'A',
                                                aviso: participante.inPresenca === 'J',
                                                neutro: !participante.inPresenca
                                            }"
                                            >{{ rotuloPresenca(participante.inPresenca) }}</span
                                        >
                                        @if (participante.dsMeioConfirmacao) {
                                            <small>{{ participante.dsMeioConfirmacao }}</small>
                                        }
                                    </td>
                                    <td class="acoes">
                                        <div class="acoes-linha">
                                            <button
                                                type="button"
                                                pButton
                                                icon="pi pi-send"
                                                severity="secondary"
                                                [text]="true"
                                                [appCan]="roleEnviarEmail"
                                                [disabled]="!permiteAlteracao || salvando"
                                                (click)="reenviarEmail(participante)"
                                                title="Reenviar e-mail"
                                            ></button>
                                            <button type="button" pButton icon="pi pi-file-pdf" severity="secondary" [text]="true" (click)="baixarOficio(participante)" title="Baixar oficio (PDF)"></button>
                                            <app-send-whatsapp [text]="gerarMensagemWhatsappConvocacao(participante)" [phone]="obterTelefoneParticipante(participante)" [abrirDialog]="true" tooltip="Enviar convocação por WhatsApp"></app-send-whatsapp>
                                            @if (participante.idParticipacao === 4) {
                                                <button
                                                    type="button"
                                                    pButton
                                                    icon="pi pi-trash"
                                                    severity="danger"
                                                    [text]="true"
                                                    [appCan]="roleRemoverConvidado"
                                                    [disabled]="!permiteAlteracao || salvando"
                                                    (click)="removerConvidado(participante)"
                                                ></button>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            }
                        }
                    </tbody>
                </table>
            </div>
        </app-card-content>

        @if (historicoEmailsVisivel) {
            <app-card-content [icon]="'pi pi-history'" [title]="'Histórico de e-mails'">
                @if (!historicoEmails.length) {
                    <div class="historico-vazio">Nenhum envio registrado.</div>
                } @else {
                    <div class="historico-lista">
                        @for (item of historicoEmails; track item.idSolicitante + '-' + item.ufSgUf + '-' + item.nmEmail) {
                            <div class="historico-item">
                                <div>
                                    <strong>{{ item.nmSolicitante || '-' }}</strong>
                                    <small>{{ item.nmEmail || '-' }}</small>
                                </div>
                                <span class="pill" [ngClass]="item.inStatusEnvioEmail === 'S' ? 'sucesso' : 'erro'">
                                    <i class="pi" [class.pi-check]="item.inStatusEnvioEmail === 'S'" [class.pi-times]="item.inStatusEnvioEmail !== 'S'"></i>
                                    {{ item.dsStatusEnvio || '-' }}
                                </span>
                            </div>
                        }
                    </div>
                }
            </app-card-content>
        }
    </section>

    <ng-template pTemplate="footer">
        <button type="button" pButton label="Fechar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
    </ng-template>
</p-dialog>

<app-pesquisar-pessoa-custom [(showDialog)]="pesquisaConvidadoVisivel" (pessoa)="adicionarConvidado($event)"></app-pesquisar-pessoa-custom>
